import {analytics } from "./../../../base/lib-jitsi-meet";
import { toggleTileView } from '../../../video-layout'; 
import { localParticipantRoleChanged,participantRoleChanged } from '../../../base/participants'; 
import { muteAllParticipants } from "../../../video-menu/actions.any";
import { MEDIA_TYPE } from "../../../base/media";
import { setVideoQuality } from "../../../video-quality/actions";
import { toggleChat } from "../../../chat/actions.web";


export let initialScreenSharingState = false;

export const createApiEvent = (action, attributes = {}) => {
    return {
        action,
        attributes,
        source: "jitsi-meet-api",
    };
};

export const sendAnalytics = (event: Object) => {
    try {
        analytics.sendEvent(event);
    } catch (e) {
        logger.warn(`Error sending analytics event: ${e}`);
    }
};

export const toggleScreenSharing = (enable) => {
    if (APP.conference.isDesktopSharingEnabled) {
        // eslint-disable-next-line no-empty-function
        APP.conference.toggleScreenSharing(enable).catch(() => {}); 
    } else {
        initialScreenSharingState = !initialScreenSharingState;
    }
}

export const ToggleChat = () => {
    sendAnalytics(createApiEvent("chat.toggled"));
    APP.store.dispatch(toggleChat());
};

export const ToggleAudio = () => {
    sendAnalytics(createApiEvent("toggle-audio"));
    APP.conference.toggleAudioMuted(false /* no UI */);
};

export const ToggleVideo = () => {
    sendAnalytics(createApiEvent("toggle-video"));
    APP.conference.toggleVideoMuted(false /* no UI */);
};

export const ToggleFilmStrip = () => {
    sendAnalytics(createApiEvent("film.strip.toggled"));
    APP.UI.toggleFilmstrip();
};

export const ToggleScreenShare = (share=true) => {
    sendAnalytics(createApiEvent("screen.sharing.toggled")); 
    toggleScreenSharing(share);  
    SendCommand("full-view-screen-share",share ? APP.conference.getMyUserId() : null)
};

export const HangupVideo = (showFeedbackDialog = true,videoCall) => {
    sendAnalytics(createApiEvent("video.hangup"));
    APP.conference.hangup(showFeedbackDialog);
    if(videoCall){
        close();
    }
};

export const AvatarUrl = (url) => {
    sendAnalytics(createApiEvent("avatar.url.changed"))
    APP.conference.changeLocalAvatarUrl(url);
};

export const VideoQuality = (frameHeight) => {
    sendAnalytics(createApiEvent("set.video.quality"));
    APP.store.dispatch(setVideoQuality(frameHeight));
};

export const MuteEveryone = () => {
    sendAnalytics(createApiEvent("muted-everyone"));
    const participants = APP.store.getState()["features/base/participants"];
    const localIds = participants
        .filter((participant) => participant.local)
        .filter((participant) => participant.role === "moderator")
        .map((participant) => participant.id);

    APP.store.dispatch(muteAllParticipants(localIds,MEDIA_TYPE.AUDIO));
};

export const ToggleTileView = () => {
    sendAnalytics(createApiEvent('tile-view.toggled'));
    APP.store.dispatch(toggleTileView());
}

export const ToggleSpeaker = (val=0) => {
    document.querySelectorAll('audio').forEach(e => {
        e.volume = val
    })
};

export const changeLocalDisplayName = (displayName) => {
    console.log("==== displayName====",displayName)
    sendAnalytics(createApiEvent('display.name.changed'));
    APP.conference.changeLocalDisplayName(displayName);
}

export const GrantNewRole = (participantID,role,isLocal=true) => {
    if(isLocal){
        APP.store.dispatch(localParticipantRoleChanged(role));
        // APP.API.notifyUserRoleChanged(participantID, role);        
    }else{
        APP.store.dispatch(participantRoleChanged(participantID, role));
    }
}

export const SendCommandOnce = (identifier,value) => { 
    let confAccess = APP.store.getState()['features/base/conference'].conference;
    confAccess.sendCommandOnce(identifier,{value});
}

export const SendCommand = (identifier,value) => {  
    let confAccess = APP.store.getState()['features/base/conference'].conference;
    confAccess.sendCommand(identifier,{value});
}


export const _getAllParticipants = ()=>{
    const { local: local_participants, remote: remote_participants } = APP.store.getState()["features/base/participants"];
    const total_participants = Array.from(remote_participants.values());
    total_participants.splice(1, 0, ...[local_participants])
    total_participants.sort((a, b) => { 
        if (a.local) {
            return -1;
        }
        if (!b.local) {
            return 1;
        }
        return 0;
    }) 
    return total_participants 
}